import { ui } from '@procuros/datachecks';

import { BooleanCell } from './cells/WebEDI/CreateEdit/BooleanCell';
import { DateCell } from './cells/WebEDI/CreateEdit/DateCell';
import { EnumerableCell } from './cells/WebEDI/CreateEdit/EnumerableCell';
import { MonetaryCell } from './cells/WebEDI/CreateEdit/MonetaryCell';
import { NumberCell } from './cells/WebEDI/CreateEdit/NumberCell';
import { TextCell } from './cells/WebEDI/CreateEdit/TextCell/TextCell';
import { ViewBooleanCell } from './cells/WebEDI/View/ViewBooleanCell/ViewBooleanCell';
import { ViewDateCell } from './cells/WebEDI/View/ViewDateCell';
import { ViewEnumerableCell } from './cells/WebEDI/View/ViewEnumerableCell';
import { ViewMonetaryCell } from './cells/WebEDI/View/ViewMonetaryCell';
import { ViewNumberCell } from './cells/WebEDI/View/ViewNumberCell';
import { ViewTextCell } from './cells/WebEDI/View/ViewTextCell';
import { ViewURLCell } from './cells/WebEDI/View/ViewURLCell';

/**
 * Map object which connects available column types to actual column cells.
 * Each connection has two components for view and edit modes.
 */

type ViewCells =
  | typeof ViewTextCell
  | typeof ViewURLCell
  | typeof ViewBooleanCell
  | typeof ViewNumberCell
  | typeof ViewMonetaryCell
  | typeof ViewDateCell
  | typeof ViewEnumerableCell;

type CreateEditCells =
  | typeof TextCell
  | typeof BooleanCell
  | typeof NumberCell
  | typeof DateCell
  | typeof EnumerableCell;

export const cellMapping: Record<ui.FieldTypes, [ViewCells, CreateEditCells] | []> = {
  [ui.FieldTypes.text]: [ViewTextCell, TextCell],
  [ui.FieldTypes.url]: [ViewURLCell, TextCell],
  [ui.FieldTypes.boolean]: [ViewBooleanCell, BooleanCell],
  [ui.FieldTypes.number]: [ViewNumberCell, NumberCell],
  [ui.FieldTypes.monetary]: [ViewMonetaryCell, MonetaryCell],
  [ui.FieldTypes.date]: [ViewDateCell, DateCell],
  [ui.FieldTypes.date_time]: [ViewDateCell, DateCell],
  [ui.FieldTypes.select]: [ViewEnumerableCell, EnumerableCell],
  [ui.FieldTypes.multi_select]: [ViewEnumerableCell, EnumerableCell],
  [ui.FieldTypes.multi_column]: [],
  [ui.FieldTypes.long_text]: [],
  [ui.FieldTypes.password]: [],
  [ui.FieldTypes.radio]: [],
  [ui.FieldTypes.text_array]: [],
  [ui.FieldTypes.external_action]: [],
  [ui.FieldTypes.file_upload]: [],
};
